import React from 'react';
import { roundedRadius } from '../Helpers';

const inputClass = '_Input-input_1v7zr_46'
const labelClass = '_Input-label_1v7zr_27'

class RadiusEditor extends React.Component {
    state = roundedRadius.parse(this.props.value || '')

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) this.setState(roundedRadius.parse(this.props.value || ''))
    }

    change = (field, value) => {
        const next = { ...this.state, [field]: value }
        this.setState(next)
        this.props.onChange(roundedRadius.build(next.size, next.location))
    }

    render() {
        const { size, location } = this.state
        const fields = [
            { key: 'size', label: 'Size', value: size, options: roundedRadius.sizes },
            { key: 'location', label: 'Location', value: location, options: roundedRadius.locations },
        ]
        return (
            <div>
                {this.props.name && <div className={labelClass}>{this.props.name}</div>}
                {fields.map(({ key, label, value, options }) => (
                    <div key={key}>
                        <div className={labelClass}>{label}</div>
                        <select value={value} onChange={(e) => this.change(key, e.target.value)} className={inputClass}>
                            {options.map((o) => (
                                <option key={o.value} value={o.value}>{o.label}</option>
                            ))}
                        </select>
                    </div>
                ))}
            </div>
        )
    }
}

export default RadiusEditor;
